<script setup lang="ts">
import { AppBackground } from '@haskoning/vue-component-library'
import { useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/project'
import { useCalculationStore } from '@/stores/calculation'
import { useProjectUserStore } from '@/stores/projectUser'
import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'
import { ref, onMounted, onUnmounted } from 'vue'
import _ from 'lodash'
import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { storeToRefs } from 'pinia'
import { useShipStore } from '@/stores/ship'
import router from '@/router'

const route = useRoute()

const projectStore = useProjectStore()
const calculationStore = useCalculationStore()

const authStore = useDjangoAuthStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()
const shipStore = useShipStore()

const { currentItem: currentProjectItem } = storeToRefs(projectStore)
const { currentItem: currentCalculationItem } = storeToRefs(calculationStore)
const { items: projectUsers } = storeToRefs(projectUserStore)
const { user: currentUser } = storeToRefs(authStore)

const isLoading = ref(true)

onMounted(async () => {
  if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
    await projectStore.fetchOptions()
    const projectId = route.params.id as string
    await projectStore.fetchItem(parseInt(projectId))

    if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
      await router.push({ name: 'not-found' })
    }
  }

  if (currentProjectItem.value) {
    const { id } = currentProjectItem.value

    if (id) {
      await projectUserStore.fetchItems({ search: id })
      await authorizationStore.fetchItems()

      const currentProjectUser = projectUsers.value.find(
        (item: ProjectUserType) => item.user === currentUser?.value?.id
      )
      authorizationStore.setCurrentRole([currentProjectUser?.role])
    }

    await shipStore.fetchOptions()
    await shipStore.fetchItems({ search: id })
  }

  if (!currentCalculationItem.value || _.isEmpty(currentCalculationItem.value)) {
    await calculationStore.fetchOptions()
    const calculationId = route.params.calculationId as string
    await calculationStore.fetchItem(parseInt(calculationId))

    if (!currentCalculationItem.value || _.isEmpty(currentCalculationItem.value)) {
      await router.push({ name: 'not-found' })
    }
  }

  isLoading.value = false
})

onUnmounted(() => {
  projectStore.resetAll()
  calculationStore.resetAll()
})
</script>

<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <AppBackground>
      <div v-if="isLoading" class="d-flex flex-column align-center justify-center fill-height">
        <v-progress-circular indeterminate color="primary" size="64" class="mb-2" />
        <span>Loading calculation data...</span>
      </div>
      <router-view v-else></router-view>
    </AppBackground>
  </div>
</template>

<style scoped></style>
